import React, { useEffect, useState } from "react";

import HttpManager from "../../../../services/HttpManager";
import { Aviso, Check, errorTexto } from "./comunes";
import { Compartido } from "./telefoniaController";

/** Ajustes de la central (solo superadmin): troncales, qué se graba, resumen diario, nombre del identificador. */
const Ajustes: React.FC<{ sh: Compartido }> = ({ sh }) => {
	const http = HttpManager.getInstance();
	const [v, setV] = useState<any | null>(null);
	const [busy, setBusy] = useState<boolean>(false);
	const [error, setError] = useState<string | null>(null);
	const [aviso, setAviso] = useState<string | null>(null);
	const [audios, setAudios] = useState<{ id: number; name: string }[]>([]);
	useEffect(() => { http.telefoniaService.ajustes(sh.campusId).then((r) => setV(r.data.ajustes)).catch((e) => setError(errorTexto(e))); }, [sh.campusId]);
	useEffect(() => { http.telefoniaService.audios(sh.campusId).then((r) => setAudios(r.data.audios)).catch(() => null); }, [sh.campusId]);
	if (!v) return <div className="nu-vacio">Cargando…</div>;
	const guardar = async () => {
		setBusy(true); setError(null);
		try { setV((await http.telefoniaService.guardarAjustes(sh.campusId, v)).data.ajustes); setAviso("Ajustes guardados. La central los toma en un minuto."); } catch (e) { setError(errorTexto(e)); } finally { setBusy(false); }
	};
	const t = v.troncales || { hn: "", mx: "" };
	const g = v.grabar || { entrantes: true, salientes: true, internas: false };
	const r = v.resumen_diario || { activo: true, hora: "20:00" };
	const b = v.bienvenida || { audio_id: null, espera: false };
	return (
		<>
			<Aviso texto={error} onClose={() => setError(null)} /><Aviso texto={aviso} tipo="ok" onClose={() => setAviso(null)} />
			<div className="tf-rejilla">
				<div className="nu-bloque">
					<div className="nu-bloque-tit">Líneas (troncales)</div>
					<span className="nu-tenue">El nombre técnico del proveedor en la central (pjsip_troncales.conf). Vacío = ese país no puede llamar. Se llena cuando el proveedor conecta.</span>
					<div className="cp-dos">
						<div><label>Honduras / El Salvador salen por</label><input type="text" value={t.hn} onChange={(e) => setV({ ...v, troncales: { ...t, hn: e.target.value } })} placeholder="claro" /></div>
						<div><label>México sale por</label><input type="text" value={t.mx} onChange={(e) => setV({ ...v, troncales: { ...t, mx: e.target.value } })} placeholder="telnyx" /></div>
					</div>
					<div className="nu-bloque-tit chico">Identificador</div>
					<div className="tf-campo"><label>Nombre que acompaña al número (si el proveedor lo muestra)</label><input type="text" value={v.cid_nombre || ""} onChange={(e) => setV({ ...v, cid_nombre: e.target.value })} /></div>
				</div>
				<div className="nu-bloque">
					<div className="nu-bloque-tit">Grabación</div>
					<Check checked={!!g.entrantes} onChange={(b) => setV({ ...v, grabar: { ...g, entrantes: b } })}>Grabar llamadas entrantes</Check>
					<Check checked={!!g.salientes} onChange={(b) => setV({ ...v, grabar: { ...g, salientes: b } })}>Grabar llamadas salientes</Check>
					<Check checked={!!g.internas} onChange={(b) => setV({ ...v, grabar: { ...g, internas: b } })}>Grabar llamadas internas (entre extensiones)</Check>
					<span className="nu-tenue">Cada extensión puede quedar fuera de la grabación en Extensiones → Editar.</span>
					<div className="nu-bloque-tit chico">Resumen diario a supervisión (Cliq)</div>
					<Check checked={!!r.activo} onChange={(b) => setV({ ...v, resumen_diario: { ...r, activo: b } })}>Enviar cada día</Check>
					<div className="tf-campo" style={{ maxWidth: 160 }}><label>A las (hora de México)</label><input type="time" value={r.hora} onChange={(e) => setV({ ...v, resumen_diario: { ...r, hora: e.target.value } })} /></div>
					<span className="nu-tenue">Cada supervisora recibe las llamadas de su territorio; superadmin recibe todo.</span>
				</div>
				<div className="nu-bloque">
					<div className="nu-bloque-tit">Bienvenida</div>
					<div className="tf-campo"><label>Saludo al contestar (en horario, todos los números)</label>
						<select value={b.audio_id || ""} onChange={(e) => setV({ ...v, bienvenida: { ...b, audio_id: e.target.value ? Number(e.target.value) : null } })}>
							<option value="">Sin saludo</option>
							{audios.map((a) => <option key={a.id} value={a.id}>{a.name}</option>)}
						</select>
					</div>
					<Check checked={!!b.espera} onChange={(x) => setV({ ...v, bienvenida: { ...b, espera: x } })}>Música mientras contesta la asesora</Check>
					<span className="nu-tenue">Los audios se suben en Audios.</span>
				</div>
			</div>
			<div style={{ marginTop: 14 }}><button className="nu-btn pri" disabled={busy} onClick={guardar}>Guardar ajustes</button></div>
		</>
	);
};

export default Ajustes;
